<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    axios.interceptors.response.use(
      response => {
        if (
          response.data.Error &&
          (response.data.Error.indexOf("使用了电脑登录,微信小程序自动退出") >
            -1 ||
            response.data.Error.indexOf("未登录") > -1 ||
            response.data.Error.indexOf("使用了手机登录,微信小程序自动退出"))
        ) {
          this.$Modal.error({
            title: "提示",
            content: response.data.Error,
            onOk: () => {
              window.location.href = "/user/login.aspx";
            },
            onCancel: () => {
              window.location.href = "/user/login.aspx";
            }
          });
        }
        return response;
      },
      err => {
        const { config, code, message } = err;
        if (code === "ECONNABORTED" || message === "Network Error") {
          console.log(
            `请求超时，将在${axios.defaults.retryDelay / 1000}秒后重试`
          );
          return new Promise(resolve => {
            setTimeout(async _ => {
              resolve(await axios.request(config), axios.defaults.retryDelay);
            });
          });
        }
      }
    );
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
html {
  background: #e9ecef;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color: #e9ecef;
}
.model {
  position: fixed;
  top: 0;
  z-index: 9997;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.modelBox {
  width: 800px;
  height: 600px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/App.vue